import {useGetCitiesByFlowQuery} from '../queries/useGetCitiesByFlowQuery/useGetCitiesByFlowQuery';
import {CitiesQueryParams} from './types';

export const useGetCitiesQuery = ({
	cdUf,
	flowType,
	cdPlanoANSOdonto,
	nuRegistroPlano,
	enabled,
}: CitiesQueryParams) =>
	useGetCitiesByFlowQuery({cdUf, flowType, cdPlanoANSOdonto, nuRegistroPlano}, enabled);
